import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { editIcon } from '../../img';

export const ItemWrap = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  position: relative;
  padding: 20px 18px;
  line-height: 30px;
  border-bottom: 1px solid rgba(40, 56, 144, 0.1);
  font-weight: normal;
  color: #28283a;

  &:hover {
    background-color: rgba(40, 56, 144, 0.05);
  }

  & .btn {
    max-height: 24px;
  }
`;

export const Title = styled.div`
  display: flex;
  font-size: 14px;
  font-weight: 700;
  color: #283890;
`;

export const Status = styled.div`
  ${(p) => css`
    border-radius: 16px;
    font-size: 12px;
    font-weight: 700;
    padding: 0 16px;
    height: 32px;
    display: flex;
    align-items: center;
    ${p.isActive
      ? css`
          background-color: #283890;
          color: white;
        `
      : css`
          background-color: rgba(39, 55, 144, 0.09);
          color: rgba(40, 40, 58, 0.5);
        `}
  `}
`;

export const MainLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
  }
`;

export const Info = styled.div`
  display: flex;
  font-size: 14px;
  gap: 4px;
`;

export const PartnerKeys = styled.div`
  ${(p) => css`
    margin: 10px 10px 0;
    font-size: 14px;
    color: #28283a;
    min-width: 440px;
    & > .header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      & span {
        transform: rotate(${p.isKeysExpanded ? 0 : -90}deg);
        transition: transform 0.2s;
        color: #283890;
      }

      & > .header--title {
        font-size: 12px;
        font-weight: bold;
        color: #283890;
        width: 100%;
        display: flex;
        align-items: center;
        margin-left: 12px;

        &::after {
          content: '';
          height: 1px;
          background: #283890;
          flex: 1;
          margin: 0 18px;
        }
      }

      & > div {
        max-height: 24px;
      }
    }
  `}
`;

export const PartnerKey = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  min-width: 356px;
  border-bottom: 1px solid rgba(40, 56, 144, 0.1);
  line-height: 30px;
  font-size: 14px !important;
  gap: 16px;

  & > .title {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  & .scope {
    font-size: 10px;
    color: rgb(103, 123, 139);
  }

  & .btn {
    max-height: 24px;
  }
`;

export const EditBtn = styled.div`
  background-image: url(${editIcon});
  background-size: 32px;
  background-repeat: no-repeat;
  min-width: 32px;
  height: 32px;
  cursor: pointer;
`;

export const ModalHeaderWrapper = styled.div`
  display: flex;
  color: #283890;
`;

export const SubmitAreaStyled = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 24px;
`;

export const WarningText = styled.p`
  color: #d32f2f; /* Красный цвет для привлечения внимания */
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.5;
`;

export const KeyContainer = styled.div`
  background-color: #f5f7f9;
  border: 1px dashed #677b8b;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: center;
  word-break: break-all;
  font-family: monospace;
  font-size: 16px;
  color: #333;
  position: relative;
`;

export const OnbordingContainer = styled.div`
  background-color: #f5f7f9;
  border: 1px dashed #677b8b;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: left;
  word-break: break-all;
  font-family: monospace;
  font-size: 16px;
  color: #333;
  position: relative;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
  min-height: 32px;
`;

export const FieldRow = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 8px;
  padding: 10px;
  border-radius: 6px;

  .switch-container {
    flex: 0 0 150px;
  }

  .input-container {
    flex: 1;
    margin: 0;
  }
`;

export const LinkStyled = styled(Link)`
  color: #283890 !important;
  display: flex;
  align-items: center;
  font-weight: 700;
  text-decoration: none;
`;
